/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Letterpreviewerror2Inputs */

const en_letterpreviewerror2 = /** @type {(inputs: Letterpreviewerror2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Couldn't load the preview. Try refreshing.`)
};

const pt_letterpreviewerror2 = /** @type {(inputs: Letterpreviewerror2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Não foi possível carregar a pré-visualização. Tente atualizar.`)
};

/**
* | output |
* | --- |
* | "Couldn't load the preview. Try refreshing." |
*
* @param {Letterpreviewerror2Inputs} inputs
* @param {{ locale?: "en" | "pt" }} options
* @returns {LocalizedString}
*/
const letterpreviewerror2 = /** @type {((inputs?: Letterpreviewerror2Inputs, options?: { locale?: "en" | "pt" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Letterpreviewerror2Inputs, { locale?: "en" | "pt" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_letterpreviewerror2(inputs)
	return pt_letterpreviewerror2(inputs)
});
export { letterpreviewerror2 as "letterPreviewError" }